export default "__VITE_ASSET__DxwdKJIm__"